import { useQuery, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { Pagination } from "../../pagination";
import Panel from "../../components/panels/panel";
import LastModifiedShowRowCard from "./modifiedItem";

interface Props {
  config: server.dto.DashboardLastModifiedPanelConfig
}

const queryKey = "lastModifiedShows";

const LastModifiedShowsPanel = (props: Props) => {
  const [page, setPage] = React.useState(1);
  const maxPerPage = 10;

  const query = useQuery({
    queryFn: async () => {
      const res = await window.CoreApi.Show.GetLastModified(page, maxPerPage);
      return res.data;
    },
    queryKey: [queryKey, page],
    keepPreviousData: true
  });

  const queryClient = useQueryClient();

  const onShowChange = () => {
    queryClient.invalidateQueries([queryKey]);
  }

  if (query.isLoading) {
    return <Panel
      title={RESX.GeneralLabels.LastModified}
      panelClassName="s1_dashboard-panel"
      isLoading={true}
    />;
  }

  return (
    <Panel
      title={props.config.headerLabel}
      pagination={<Pagination
        paginationData={query.data.pagination}
        onPaginate={setPage}
        noInitialPagination
      />}
      hasData={query.data.data.length > 0}
      hasError={query.isError}
      isLoading={query.isLoading}
      panelClassName="s1_dashboard-panel"
    >
      <div className="list-with-gaps line-layout">
        <div className="list-with-gaps-body">
          {query.data.data.map(
            lastModifiedShow => <LastModifiedShowRowCard
              onShowChange={onShowChange}
              key={lastModifiedShow.showId}
              lastModifiedShow={lastModifiedShow}
            />
          )}
        </div>
      </div>
    </Panel >
  );
};
export default LastModifiedShowsPanel;
